/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationResponsiblePersonSearchOrderByPaginationQuery } from './ApplicationResponsiblePersonSearchOrderByPaginationQuery';
import {
    ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSON,
    ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSONTyped,
    ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSON,
    ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSONTyped,
} from './ApplicationResponsiblePersonSearchOrderByPaginationQuery';

/**
 * 
 * @export
 * @interface ApplicationResponsiblePersonSearchRequest
 */
export interface ApplicationResponsiblePersonSearchRequest {
    /**
     * 
     * @type {ApplicationResponsiblePersonSearchOrderByPaginationQuery}
     * @memberof ApplicationResponsiblePersonSearchRequest
     */
    paginationQuery?: ApplicationResponsiblePersonSearchOrderByPaginationQuery;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationResponsiblePersonSearchRequest
     */
    applicationIds?: Array<string> | null;
}

/**
 * Check if a given object implements the ApplicationResponsiblePersonSearchRequest interface.
 */
export function instanceOfApplicationResponsiblePersonSearchRequest(value: object): value is ApplicationResponsiblePersonSearchRequest {
    return true;
}

export function ApplicationResponsiblePersonSearchRequestFromJSON(json: any): ApplicationResponsiblePersonSearchRequest {
    return ApplicationResponsiblePersonSearchRequestFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationQuery': json['paginationQuery'] == null ? undefined : ApplicationResponsiblePersonSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
        'applicationIds': json['applicationIds'] === undefined ? undefined : json['applicationIds'] === null ? null : json['applicationIds'],
    };
}

export function ApplicationResponsiblePersonSearchRequestToJSON(json: any): ApplicationResponsiblePersonSearchRequest {
    return ApplicationResponsiblePersonSearchRequestToJSONTyped(json, false);
}

export function ApplicationResponsiblePersonSearchRequestToJSONTyped(value?: ApplicationResponsiblePersonSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationQuery': ApplicationResponsiblePersonSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
        'applicationIds': value['applicationIds'],
    };
}

